// extracted by mini-css-extract-plugin
export default {"cart-div":"customCart_cart-div__i0EOZ"};